import { createAsyncThunk } from '@reduxjs/toolkit';

import { searchArticles, SearchArticlesItem } from '../api/searchArticles';
import { HttpClientFactory } from '../httpClient';

export const loadSolutions = createAsyncThunk<
  SearchArticlesItem[],
  {
    query: string;
    limit: number;
    offset: number;
    filters: {
      categoriesIds?: string[];
      excludedCategoriesIds?: string[];
    };
    httpClient: HttpClientFactory;
  }
>('loadSolutions', async ({ query, limit, offset, filters, httpClient }) => {
  const newArticles = await searchArticles(query, limit, offset, httpClient, filters);

  return newArticles;
});
